import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from '../../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import {
  CreateRacunFromSefRacunCommand,
  IApiMenadzmentDto,
  MojaFirmaClient,
  ResultOfApiMenadzmentDto,
  SefClient
} from '@kodit/core/data-api';
import { AlertService } from '@kodit/core/services';
import { MojaFirmaApiCardFormComponent } from '../moja-firma-api-card-form/moja-firma-api-card-form.component';

@Component({
  selector: 'kodit-moja-firma-api-otpremnice',
  templateUrl: './moja-firma-api-otpremnice.component.html',
  styleUrls: ['./moja-firma-api-otpremnice.component.scss']
})
export class MojaFirmaApiOtpremniceComponent implements OnInit, OnDestroy {

  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Configuration */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  /** Props */
  apiMenadzmentDto: IApiMenadzmentDto;

  constructor(
    private _dialogService: DynamicDialogService,
    private _client: MojaFirmaClient,
    private _sefClient: SefClient,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this._load();
  }

  onEdit() {
    this.dialogConfig.data = {
      apiKeySEF: this.apiMenadzmentDto.apiKeyZaOtpremnice,
      isDeliveryNote: true
    };
    this.dialogConfig.header = 'Izmena API menadžmenta';
    this.openDialog(this.dialogConfig);
  }

  openDialog(config: DynamicDialogConfig): void {
    const ref = this._dialogService.open(MojaFirmaApiCardFormComponent, config);

    this._subs.add(
      ref.onClose.subscribe((dto: ResultOfApiMenadzmentDto) => {
        if (dto) {
          this.apiMenadzmentDto = dto.data;
        }
      })
    );
  }

  private _load() {
    this._subs.add(
      this._client.getApiMenadzment().subscribe((result) => {
        this.apiMenadzmentDto = result.data;
      })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

}
